















































































































import { Component } from 'vue-property-decorator';
//import { LendingRevolvingCreditModule } from '@/store/Accounts/LendingRevolvingCreditModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import InterestRateType from '@/models/Products/InterestRateType';
import ListUtils from '@/lib/listUtils';
import LendingRevolvingCreditInstalmentPlanTermDefinitionCreate from '@/components/Products/Forms/Lending/LendingRevolvingCreditInstalmentPlanTermDefinitionCreate.vue'

@Component({ name: 'LendingRevolvingCreditInstalmentPlanInterestSettingsCreate', components: { LendingRevolvingCreditInstalmentPlanTermDefinitionCreate } })
export default class extends SaascadaVue {

    interestRateType = InterestRateType;

    headers = [
        { text: 'Term (Months)', value: 'lengthMonths' },
        { text: 'Interest Rate', value: 'rateValue' },
        { text: 'Actions' },
    ]


    get productVM() {
        return {
        instalmentPlanInterestSettings: {}
        };
        //return LendingRevolvingCreditModule.createProductViewModel;
    }

    get interestRateTypeOptions() {
        return ListUtils.interestRateTypeOptions();
    }

    get interestCalculatedOnOptions() {
        return ListUtils.interestCalculatedOnOptions();
    }

    get interestPostedTypeOptions() {
        return ListUtils.interestPostedTypeOptions();
    }

    get periodTypeOptions() {
        return ListUtils.periodTypeOptions();
    }

    get nonWorkingDaysOptions() {
        return ListUtils.nonWorkingDaysOptions();
    }

    get daysInYearOptions() {
        return ListUtils.interestDaysInYearOptions();
    }

    get baseRateOptions() {
        return ListUtils.interestBaseRateOptions();
    }
}
